// appwriteConfig.js
import { Client, Account, Databases, Storage, Query} from 'appwrite';

// Initialize the Appwrite client
const client = new Client()
    .setEndpoint('https://cloud.appwrite.io/v1') // Your Appwrite Endpoint
    .setProject('6696b77c002fc19af7ab'); // Your Project ID

// Initialize services
const account = new Account(client);
const databases = new Databases(client);
const storage = new Storage(client);

export { client, account, databases, storage , Query};
